<template>
  <div class="area-selected">
    <Cascader
      v-model="selectedValue"
      :data="areaData"
      change-on-select
      @on-change="handleChange"
      placeholder="请选择省市区"
      style="width: 100%"
    />
  </div>
</template>

<script>
import areaData from './area.js'
console.log('areaData', areaData)
export default {
  name: 'AreaSelected',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    level: {
      type: [String, Number],
      default: 3
    }
  },
  data () {
    return {
      selectedValue: [],
      areaData: []
    }
  },
  watch: {
    value: {
      handler (val) {
        this.selectedValue = val || []
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    console.log('created')
    this.areaData = areaData
  },
  methods: {
    // 选择改变时触发
    handleChange (value, selectedData) {
      // 根据level属性限制选择层级
      if (this.level && value.length > Number(this.level)) {
        value = value.slice(0, Number(this.level))
        selectedData = selectedData.slice(0, Number(this.level))
        this.selectedValue = value
      }

      // 构建包含label的数据
      const result = selectedData.map(item => ({
        value: item.value,
        label: item.label
      }))
      console.log('result', result)
      this.$emit('input', value)
      this.$emit('on-change', value, result)
    }
  }
}
</script>

<style lang="less" scoped>
.area-selected {
  width: 100%;
}
</style>
